// extracted by mini-css-extract-plugin
export default {"container":"tpms-accessory-message__container___11-gD"};